var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.473 18.8939L13.9999 18.3669L14.5269 18.8939L13.9999 19.4208L13.473 18.8939ZM14.9394 18.4814L14.7041 18.2461H15.1747L14.9394 18.4814ZM13.2958 18.2461L13.0605 18.4814L12.8252 18.2461H13.2958ZM12.3795 14.8676V17.8004L6.82906 12.25L8.29548 10.7836L12.3795 14.8676ZM13.2958 17.6628H12.9628V17.3298L13.2958 17.6628ZM13.5874 16.0755L12.9628 16.7002V15.4509L13.5874 16.0755ZM13.473 17.015L13.9999 16.488L14.5269 17.015L13.9999 17.5419L13.473 17.015ZM15.037 16.7002L14.4124 16.0755L15.037 15.4509V16.7002ZM14.7041 17.6628L15.037 17.3298V17.6628H14.7041ZM15.6204 17.8004V14.8676L19.7044 10.7836L21.1708 12.25L15.6204 17.8004ZM15.037 6.28709L15.037 14.6259L13.9999 15.6631L12.9628 14.6259L12.9628 6.28709L15.037 6.28709ZM14.9952 5.70376L13.0047 5.70376C13.0531 5.53838 13.1425 5.38613 13.2666 5.26207C13.4611 5.06758 13.7249 4.95831 13.9999 4.95831C14.275 4.95831 14.5388 5.06758 14.7333 5.26207C14.8573 5.38613 14.9467 5.53838 14.9952 5.70376Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.583333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 19.8333V21.1944C4.66675 21.9164 4.9477 22.6088 5.4478 23.1193C5.94789 23.6298 6.62617 23.9166 7.33341 23.9166H20.6667C21.374 23.9166 22.0523 23.6298 22.5524 23.1193C23.0525 22.6088 23.3334 21.9164 23.3334 21.1944V19.8333",
    stroke: "white",
    strokeWidth: 2.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.852ceb488a1d439f391955f78e25d4e6.svg";
export { ForwardRef as ReactComponent };